import { useTrackingEvent } from "./useTrackingEvent";
export const useTrackingSimilarListingLoad = (similarListings) => {
    const items = similarListings.map((item) => item.tracking);
    const EVENT_DATA = {
        event: "view_item_list",
        av_items: items,
        av_category: "classified",
    };
    return useTrackingEvent(EVENT_DATA);
};
